import script from "./TransferChangeWifiPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferChangeWifiPage.vue?vue&type=script&setup=true&lang=js"

import "./TransferChangeWifiPage.vue?vue&type=style&index=0&id=0b8ed6a8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b8ed6a8"]])

export default __exports__